import type { SeoMeta } from '$lib/seo';

export const load = (): { seo: SeoMeta } => ({
	seo: {
		title: 'On privacy',
		description:
			'A short letter on what Ekavi Care collects from this website, what we do not, and what you can ask for at any time. GDPR Art. 13/14, CCPA, and the HIPAA NPP update.',
		path: '/privacy/',
		pageType: 'WebPage',
		robots: 'noindex, follow'
	}
});
